import React from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { numDifferentiationWithoutSymbol } from "../../CommonMethhods/CovertRupees";
import LoaderForSearch from "../Common/LoaderForSearch";

function RevenueTableNew(props) {
  let gridVal = props?.gridVal;
  const handleScroll = props?.handleScroll;
  const scrollLoader = props?.scrollLoader;
  const totalValue = props.totalValue;
  
  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper ">
        {gridVal && gridVal ? (
          <table className="table last-column">
            <thead>
              <tr>
              <th scope="col" className="text-center">
                  Party Code
                </th>
              <th scope="col" className="text-center">
                  {Constants.client_Name}
                </th>
                <th scope="col" className="text-center">
                  Gross Brokerage Income
                </th>
                <th scope="col" className="text-center">
                  MTF ROI
                </th>
                <th scope="col" className="text-center">
                  Branch
                </th>
                <th scope="col" className="text-center">
                  Regional Code
                </th>
                <th scope="col" className="text-center">
                  Zonal Code
                </th>
                <th scope="col" className="text-center">
                  RM Name
                </th>
                <th scope="col" className="text-center">
                  Dealer Name
                </th>
              </tr>
            </thead>
            <tbody id="clientrevenue-scroll" onScroll={handleScroll}>
              {gridVal &&
                gridVal.map((item, key) => {
                  return (
                    <tr key={key}>
                    <td>{item?.partyCode || "-"}</td>
                      <td>{item?.clientName || "-"}</td>
                      <td>{item?.grossBrokerageIncome || 0}</td>
                      <td>{item?.mtfRoi || 0}</td>
                      <td>{item?.branch || "-"}</td>
                      <td>{item?.region || "-"}</td>
                      <td>{item?.zone || "-"}</td>
                      <td>{item?.rmName || "-"}</td>
                      <td>{item?.dealerName || "-"}</td>

                    </tr>
                  );
                })}
              {scrollLoader && (
                <div className="loader-center">
                  <LoaderForSearch />
                </div>
              )}
            </tbody>
              <tbody className="totalRevnueData rev-table-new">
                <tr>
                  <td>Total</td>
                  <td></td>
                  <td>
                    {totalValue?.totalBrokerageIncome || 0}
                  </td>
                  {/* <td>
                    {totalValue?.totalBrokerageReversal || 0}
                  </td> */}
                  {/* <td>
                    {totalValue?.totalNetbrokerage || 0}
                  </td> */}
                  <td>
                    {totalValue?.totalMtfRoi || 0}
                  </td>
                  {/* <td>
                    {totalValue?.totalMtfint || 0}
                  </td> */}
                  {/* <td>
                    {totalValue?.totalMtfReversal || 0}
                  </td>
                  <td>
                    {totalValue?.totalNetMtfInt || 0}
                  </td>
                  <td>
                    {totalValue?.totalDpIncome || 0}
                  </td>
                  <td>
                    {totalValue?.totalDpReversal || 0}
                  </td>
                  <td>
                    {totalValue?.totalNetDpInc || 0}
                  </td>
                  <td>
                    {totalValue?.totalNetIncome || 0}
                  </td>
                  <td>
                    {totalValue?.totalDpcRoi || 0}
                  </td>
                  <td>
                    {totalValue?.totalDpcInt || 0}
                  </td>
                  <td>
                    {totalValue?.totalDpcReversal || 0}
                  </td>
                  <td>
                    {totalValue?.totalNetDpc || 0}
                  </td> */}
                  {/* <td>
                    {totalValue?.totalNetBranchInc || 0}
                  </td> */}
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  

                </tr>
              </tbody>
          </table>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
export default RevenueTableNew;
